/* Precios que cuentan de 0 hasta su valor cuando entran en pantalla.

   Vive en un asset compartido y no dentro de cada seccion: el mismo efecto se
   usa en la ficha de producto, en las tarjetas de packs, en "mas vendidos" y en
   "productos similares". Escrito cuatro veces se iria despegando al primer
   ajuste.

   Como marcar un precio:
     <span data-gf-count="49500">$495.00</span>        cuenta una vez
     <span data-gf-count="49500" data-gf-pulso>...</span>  ademas late siempre
     <span data-gf-count="44550" data-gf-desde="49500">   BAJA de 495 a 445.50

   Con data-gf-desde el numero arranca en el precio de lista y DESCIENDE hasta
   el de transferencia. Es al reves de como estaba: contar desde 0 hacia arriba
   se lee como que el precio sube, justo lo contrario de lo que comunica un
   descuento. Sin ese atributo (o si el de partida no es mayor) se comporta como
   antes y sube desde 0.

   El valor va en CENTAVOS, que es como lo entrega Liquid.

   OJO: este atributo es SOLO para precios. La seccion de estadisticas
   (griflor-story) usaba el mismo `data-gf-count` para numeros pelados y
   este script se los comia formateados como plata: 25 salia "$0.25" y
   300 salia "$3.00". Pasaba de a ratos porque los dos scripts observaban
   el mismo nodo y ganaba el que corria ultimo. Los contadores que no son
   precios usan `data-gf-num`. */
(function () {
  if (window.gfPrecioAnim) { return; }
  window.gfPrecioAnim = true;

  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function money(cents) {
    try {
      return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function contar(el) {
    var hasta = parseInt(el.getAttribute('data-gf-count'), 10) || 0;
    if (!hasta) { return; }

    /* de donde arranca: el precio de lista si esta, y si no 0 como siempre.
       Se exige que sea MAYOR, asi un producto sin descuento no baja al reves. */
    var desde = parseInt(el.getAttribute('data-gf-desde'), 10) || 0;
    if (desde <= hasta) { desde = 0; }

    if (REDUCE) { el.textContent = money(hasta); marcarListo(el); return; }

    var dur = 900, t0 = null;
    el.classList.add('is-contando');

    function paso(ts) {
      if (t0 === null) { t0 = ts; }
      var k = Math.min(1, (ts - t0) / dur);
      /* easeOutExpo: sale rapido y frena al final, asi el numero aterriza */
      var e = k === 1 ? 1 : 1 - Math.pow(2, -10 * k);
      el.textContent = money(Math.round(desde + (hasta - desde) * e));
      if (k < 1) {
        requestAnimationFrame(paso);
      } else {
        el.textContent = money(hasta);
        el.classList.remove('is-contando');
        marcarListo(el);
      }
    }
    requestAnimationFrame(paso);
  }

  function marcarListo(el) {
    el.classList.add('is-listo');
    setTimeout(function () {
      el.classList.remove('is-listo');
      /* el latido permanente arranca recien cuando termino de contar, si no se
         pisan las dos animaciones sobre el mismo transform */
      if (el.hasAttribute('data-gf-pulso') && !REDUCE) { el.classList.add('is-pulso'); }
    }, 700);
  }

  function init() {
    var nodos = document.querySelectorAll('[data-gf-count]:not([data-gf-visto]):not([data-gf-num])');
    if (!nodos.length) { return; }

    if (!('IntersectionObserver' in window)) {
      nodos.forEach(function (el) { el.setAttribute('data-gf-visto', '1'); contar(el); });
      return;
    }
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) { return; }
        io.unobserve(e.target);
        contar(e.target);
      });
    }, { threshold: 0.6 });

    nodos.forEach(function (el) {
      el.setAttribute('data-gf-visto', '1');
      io.observe(el);
    });
  }

  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', init); }
  document.addEventListener('shopify:section:load', init);
})();
